var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("section", { staticClass: "pt-12 pt-md-14 mt-n11 bg-primary" }),
    _vm._v(" "),
    _c("section", { staticClass: "position-relative pt-12 pt-md-14 mt-n11" }, [
      _c("div", { staticClass: "container" }, [
        _c(
          "div",
          { staticClass: "row align-items-center text-center text-md-start" },
          [
            _c("div", { staticClass: "col-12 col-md-12" }, [
              _vm._m(0),
              _vm._v(" "),
              _c("dl", [
                _c("dt", { staticClass: "fs-lg text-primary-desat mt-2" }, [
                  _vm._v("Do you have a plan to make over a million requests?"),
                ]),
                _vm._v(" "),
                _c("dd", { staticClass: "fs-lg text-muted p-3" }, [
                  _vm._v(
                    "\n                            Yes, you can write to us by "
                  ),
                  _c(
                    "a",
                    { attrs: { href: `mailto:${_vm.$root.siteEmail}` } },
                    [_vm._v("our mail")]
                  ),
                  _vm._v("\n                            or "),
                  _c(
                    "a",
                    {
                      attrs: {
                        href: `https://t.me/${_vm.$root.siteTgSupport}`,
                      },
                    },
                    [_vm._v("telegram")]
                  ),
                ]),
                _vm._v(" "),
                _c("dt", { staticClass: "fs-lg text-primary-desat mt-2" }, [
                  _vm._v("Will my funds expire at the end of the month?"),
                ]),
                _vm._v(" "),
                _c("dd", { staticClass: "fs-lg text-muted p-3" }, [
                  _vm._v(
                    "\n                            No, we only charge for successful requests. if you stop making requests your balance will remain unchanged\n                        "
                  ),
                ]),
                _vm._v(" "),
                _c("dt", { staticClass: "fs-lg text-primary-desat mt-2" }, [
                  _vm._v("What requests do you charge for?"),
                ]),
                _vm._v(" "),
                _c("dd", { staticClass: "fs-lg text-muted p-3" }, [
                  _vm._v(
                    "\n                            We charge for any successful response (such as 200, 403, 404). For 50x errors we do not charge\n                        "
                  ),
                ]),
                _vm._v(" "),
                _c("dt", { staticClass: "fs-lg text-primary-desat mt-2" }, [
                  _vm._v("What are the differences between API versions?"),
                ]),
                _vm._v(" "),
                _vm._m(1),
                _vm._v(" "),
                _c("dt", { staticClass: "fs-lg text-primary-desat mt-2" }, [
                  _vm._v(
                    "What is the best endpoint to use to get followers/followings?"
                  ),
                ]),
                _vm._v(" "),
                _vm._m(2),
              ]),
            ]),
          ]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("h1", { staticClass: "display-1 fw-bold" }, [
      _c("div", [_vm._v("FAQ")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("dd", { staticClass: "fs-lg text-muted p-3" }, [
      _c("strong", [_vm._v("Version v1:")]),
      _vm._v(" Our v1 API provides validated data, ensuring compliance"),
      _c("br"),
      _vm._v(
        "\n                            with standards. You receive necessary and verified fields, simplifying"
      ),
      _c("br"),
      _vm._v("\n                            integration and reducing errors."),
      _c("br"),
      _c("br"),
      _vm._v(" "),
      _c("strong", [_vm._v("Version v2:")]),
      _vm._v(" The v2 API delivers raw data, as originally provided."),
      _c("br"),
      _vm._v(
        "\n                            In rare cases, some fields may be modified or added, possibly"
      ),
      _c("br"),
      _vm._v(
        "\n                            resulting in data that doesn’t match your expectations."
      ),
      _c("br"),
      _c("br"),
      _vm._v(" "),
      _c("strong", [_vm._v("Version gql:")]),
      _vm._v(
        " The gql API provides the ability to select and query specific data,"
      ),
      _c("br"),
      _vm._v(
        "\n                            allowing you to retrieve only relevant information, without unnecessary data."
      ),
      _c("br"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("dd", { staticClass: "fs-lg text-muted p-3" }, [
      _vm._v(
        "\n                            To retrieve follower data, use the following endpoints:"
      ),
      _c("br"),
      _c("br"),
      _vm._v(" "),
      _c("strong", [_vm._v("v1:")]),
      _c("br"),
      _vm._v(
        "\n                            - /v1/user/following/chunk — 200 records on request."
      ),
      _c("br"),
      _vm._v(
        "\n                            - /v1/user/followers/chunk — 100 records on request."
      ),
      _c("br"),
      _c("br"),
      _vm._v(" "),
      _c("strong", [_vm._v("v2:")]),
      _c("br"),
      _vm._v(
        "\n                            - /v2/user/following — 100 records on request."
      ),
      _c("br"),
      _vm._v(
        "\n                            - /v2/user/followers — 200 records on request."
      ),
      _c("br"),
      _c("br"),
      _vm._v(" "),
      _c("strong", [_vm._v("gql:")]),
      _c("br"),
      _vm._v(
        "\n                            Allows you to collect follower data on verified users"
      ),
      _c("br"),
      _vm._v(
        "\n                            - /gql/user/followers/chunk — 50 records on request."
      ),
      _c("br"),
      _vm._v(
        "\n                            - /gql/user/following/chunk — 50 records on request."
      ),
      _c("br"),
      _c("br"),
      _vm._v(" "),
      _c("strong", [_vm._v("Note:")]),
      _vm._v(" Data are usually provided in the specified amounts, "),
      _c("br"),
      _vm._v(
        "\n                            but the number of records may vary depending on the external service\n                        "
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }